// Hooks
import { useGlobalInfo } from '@/utils/hooks/context/useGlobalInfo';
import useToastsNotifications from '@/utils/hooks/swr/notifications/useToastsNotifications';
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';
import useUrlUserHomepage from '@/utils/hooks/user/useUrlUserHomepage';
import useToggle from '@/utils/hooks/utils/useToggle';

// Components
import Icon from '@/components/base/Icon';
import LinkBase from '@/components/base/LinkBase';
import NotificationsCounter from '@/components/base/NotificationsCounter';
import MenuSidebar from '@/components/composite/MenuMobile/MenuSidebar';
import SocialProfileAvatar from '@/components/composite/SocialProfiles//SocialProfileAvatar';
import { AvatarDisplayed } from '@/components/composite/SocialProfiles/Components/AvatarMenu';
import { SocialProfileGroupMobileMenu } from '@/components/composite/SocialProfiles/SocialProfileGroupMenuMobile';
import Iconosquare from '@/components/icons/Iconosquare';

const MenuMobile = () => {
    const { globalInfo } = useGlobalInfo();
    const { unreadNotifications, hasUnreadNotifications } = useToastsNotifications({
        revalidateOnMount: false,
        shouldRetryOnError: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    });
    const { activeSocialProfile } = useActiveSocialProfile();
    const { userHomepage } = useUrlUserHomepage();

    const { isOpen: isOpenMenu, toggle: toggleMenu } = useToggle();
    const { isOpen: isOpenSocialProfiles, toggle: toggleSocialProfiles } = useToggle();

    return (
        <div
            className="flex h-13 w-full items-center justify-between px-m py-2.5 md:hidden"
            data-testid="navigation-menu-mobile">
            <div className="flex space-x-m align-middle">
                <div className="relative flex align-middle">
                    <button className="leading-none text-icoGray-500" onClick={toggleMenu}>
                        <Icon icon="menu-burger" className="align-middle" />
                        {hasUnreadNotifications ? (
                            <NotificationsCounter className="absolute -right-2 -top-1">
                                {unreadNotifications > 20 ? '20+' : unreadNotifications}
                            </NotificationsCounter>
                        ) : null}
                    </button>
                </div>
                <LinkBase
                    className="flex items-center space-x-2 text-xs leading-none"
                    href={userHomepage}>
                    <Iconosquare size={16} className="text-icoBlue" />
                    <p className="font-GSemiBold">iconosquare</p>
                </LinkBase>
            </div>
            {activeSocialProfile ? (
                <button
                    className="rounded-full"
                    onClick={toggleSocialProfiles}
                    data-testid="menu-mobile-display-social-profile">
                    <SocialProfileAvatar
                        size="sm"
                        className="align-top"
                        profile={activeSocialProfile}
                        selected
                    />
                </button>
            ) : null}
            {globalInfo.group.activeGroup && !activeSocialProfile ? (
                <button
                    className="rounded-md"
                    onClick={toggleSocialProfiles}
                    data-testid="menu-mobile-display-group">
                    <AvatarDisplayed
                        compact
                        variant="group"
                        data={globalInfo.group.activeGroup}
                        size="md"
                        selected
                    />
                </button>
            ) : null}
            <MenuSidebar isOpenMenu={isOpenMenu} toggleMenu={toggleMenu} />
            <SocialProfileGroupMobileMenu
                isOpenSidebar={isOpenSocialProfiles}
                toggleSideBar={toggleSocialProfiles}
            />
        </div>
    );
};

export default MenuMobile;
